import { render, staticRenderFns } from "./customDate.vue?vue&type=template&id=133d1e61&"
import script from "./customDate.vue?vue&type=script&lang=js&"
export * from "./customDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports